<template>
    <div>
        <div class="modal fade offer notification" id="notificationModal" tabindex="-1" role="dialog"
             aria-labelledby="notificationModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <ul>
                            <li
                                v-for="notification in notifications"
                                :key="notification.id"
                                :class="{ read: !!notification.read_at}"
                                class="notification-item"
                            >
                                <i class="fa fa-trash delete-notification-icon"
                                   @click="deleteNotification(notification)"></i>
                                    <span v-html="notification.message"></span>
                                <span class='notification-time'>{{notification.created_at | moment("MMM Do YYYY, HH:mm") }}</span>
                                <hr/>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary save" data-dismiss="modal"
                                @click="markNotificationsRead">Mark All as Read
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="menu-patr mobile closed">

            <div class="swipe visible-xs visible-sm"></div>
            <div class="menu" v-on-clickaway="closeMobileMenu">
                <ul>
                    <li class="first">
                        <router-link :to="{ name: 'dashboard' }">My Home</router-link>
                        <a href="#" class="menu-notification"
                           v-bind:style="{ animationPlayState: notificationAnimationState }" data-toggle="modal"
                           data-target="#notificationModal"><span>{{ newNotifications.length }}</span></a>
                        <!--                        <a v-if="notifications.length > 0" href="#" style="" class="" data-toggle="modal" data-target="#notificationModal"><span>{{ newNotifications.length }}</span></a>-->
                    </li>
                    <li class="dropdown" v-if="$_userCanPostOffers && $_userCanAcceptOffers">
                        <a class="current-page dropdown-toggle" data-toggle="drop-down"
                           @click="toggleMatchedOffersDropDown">Transactions <span><i
                            class="fa fa-angle-right"></i></span></a>
                        <ul class="dropdown-menu">
                            <li>
                                <router-link :to="{ name: 'transfers' }" @click.native="closeMenu">Posted Offers
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'transfers' }" @click.native="closeMenu">Matched
                                    Offers
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-else>
                        <router-link v-if="$_userCanPostOffers" :to="{ name: 'transfers' }"
                                     @click.native="closeMenu">Transactions
                        </router-link>
                        <router-link v-if="$_userCanAcceptOffers" :to="{ name: 'transfers' }"
                                     @click.native="closeMenu">Transactions
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'offers-list' }" @click.native="closeMenu">Global Offers</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'recipient-list' }" @click.native="closeMenu">Recipient List
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'rate-alert-create' }" @click.native="closeMenu">Rate Alert
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'user-profiles' }" @click.native="closeMenu">Profiles</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'user-settings' }" @click.native="closeMenu">Settings</router-link>
                    </li>
                    <li>
                        <a href="#">Help &amp; Support</a>
                    </li>
                    <li>
                        <a v-if="!loading" @click.prevent="logout" class="menu-button">Logout</a>
                        <a v-else class="menu-button">Logging out...</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {mixin as clickaway} from 'vue-clickaway';
    import MySocket from '../../services/MySocket';

    export default {
        name: "Menu",
        methods: getMethods(),
        computed: getComputed(),
        mixins: [clickaway],
        mounted: mounted,
        data: data,
        watch: getWatchers(),
        beforeDestroy: beforeDestroy
    }

    function getWatchers() {
        return {
            /**
             * Start pulse and make sound when a notification is changed.
             *
             * @param value
             */
            notifications: function (value) {
                let currentNotificationCount = this.notifications.length;

                if (currentNotificationCount > this.previousNotificationCount && !this.firstLoad) {
                    let soundFile = "/sounds/notification.mp3";
                    let theSound = new Audio(soundFile);
                    theSound.play();

                    let that = this;

                    this.notificationAnimationState = 'running';
                } else {
                    this.firstLoad = false;
                }

                this.previousNotificationCount = this.notifications.length;
            }
        }
    }

    function beforeDestroy() {
        const vm = this;
        removeSocketListener();

        function removeSocketListener() {
            MySocket.remove('notification')
        }
    }

    function data() {
        return {
            rotateDropdown: false,
            loading: false,
            notifications: [],
            previousNotificationCount: 0,
            notificationAnimationState: 'paused',
            timeouts: [],
            firstLoad: true,
        }
    }

    function getMethods() {
        return {
            logout: logout,
            closeMobileMenu: closeMobileMenu,
            closeMenu: closeMenu,
            openMatchedOffersDropDown: openMatchedOffersDropDown,
            closeMatchedOffersDropDown: closeMatchedOffersDropDown,
            toggleMatchedOffersDropDown: toggleMatchedOffersDropDown,
            markNotificationsRead: markNotificationsRead,
            deleteNotification: deleteNotification,
        };

        function closeMobileMenu(event) {
            const vm = this;
            const eventTargetIsOpenMenuButton = event.target.className.includes('navbar-toggle') || event.target.className.includes('icon-bar');
            if (!eventTargetIsOpenMenuButton) {
                vm.$store.commit('menuIsClosed', true);
                window.closeMenu();
            }
        };

        function closeMenu() {
            const vm = this;
            vm.$store.commit('menuIsClosed', true);
            window.closeMenu()
        }

        function logout() {
            const vm = this;

            vm.loading = true;
            vm.$store.commit('setHandlingSession', true);
            Vue.backendApi().logout().then(logoutSuccess, logoutError);

            function logoutSuccess(response) {
                vm.loading = false;
                vm.$store.commit('storeUser', {});
                vm.$store.commit('storeAuthToken', {});
                localStorage.removeItem('user');
                localStorage.removeItem('authToken');
                vm.$router.push({name: 'login'});
            }

            function logoutError(error) {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'An error occurred.',
                    text: error
                });
            }


        }

        function openMatchedOffersDropDown() {
            $('.current-page.dropdown-toggle span').css({'transform': 'rotate(' + 0 + 'deg)'});
            $('.dropdown .dropdown-menu').css('display', 'none');
            $('.dropdown .dropdown-menu li').css('opacity', 0);
            $('.dropdown .dropdown-menu li').css('height', 0);
            $('.dropdown .dropdown-menu a').css('display', 'none');
            this.rotateDropdown = false;
        }

        function closeMatchedOffersDropDown() {
            $('.current-page.dropdown-toggle span').css({'transform': 'rotate(' + 90 + 'deg)'});
            $('.dropdown .dropdown-menu').css('display', 'block');
            $('.dropdown .dropdown-menu li').css('opacity', 1);
            $('.dropdown .dropdown-menu li').css('height', '53px');
            setTimeout(function () {
                $('.dropdown .dropdown-menu a').css('display', 'block');
            }, 500);
            this.rotateDropdown = true;
        }

        function toggleMatchedOffersDropDown() {
            if (window.innerWidth < 992) {
                if (this.rotateDropdown) {
                    this.openMatchedOffersDropDown();
                } else {
                    this.closeMatchedOffersDropDown();
                }
            }
        }

        function markNotificationsRead() {
            const vm = this;
            var notificationIds = this.newNotifications.map(notification => notification.id);

            if (notificationIds.length < 1) {
                return;
            }

            const payload = {
                notification_ids: notificationIds
            }

            Vue.backendApi().notifications().markAsRead(payload)
                .then(success, error);

            function success(response) {
                vm.notificationAnimationState = 'paused';

                vm.notifications = vm.notifications.map(notification => {
                    if (notificationIds.indexOf(notification.id) >= 0) {
                        notification.read_at = new Date()
                    }
                    return notification
                })
            }

            function error(error) {
                vm.$swal({
                    type: 'error',
                    title: 'Error marking notifications as read',
                    text: error
                });
            }
        }

        function deleteNotification(notification) {
            const vm = this;

            if (!notification.id) {
                return;
            }

            Vue.backendApi().notifications().destroy(notification.id)
                .then(success, error);


            function success(response) {
                vm.notifications = vm.notifications.filter(_notification => _notification.id !== notification.id)

                if (!vm.notifications || vm.notifications.length === 0) {
                    vm.notificationAnimationState = 'paused';
                }
            }

            function error(error) {
                vm.$swal({
                    type: 'error',
                    title: 'Error marking notifications as read',
                    text: error
                });
            }
        }


    }

    function getComputed() {
        return {
            menuIsClosed: menuIsClosed,
            newNotifications: newNotifications
        };

        function menuIsClosed() {
            const vm = this;
            return vm.$store.state.menuIsClosed;
        }

        function newNotifications() {
            return this.notifications.filter((item) => {
                return !item.read_at;
            })
        }
    }

    function mounted() {
        const vm = this;
        addSocketListeners()
        getNotifications();

        var outsideSwipe = 0;
        var menuWidth = $('.menu-patr.mobile').width();
        outsideSwipe = $(window).width() - menuWidth;
        $('.menu-patr.mobile .swipe').width(outsideSwipe);

        $(".menu-patr.mobile .swipe").on("swipeleft", swipeleftHandler);
        $(".menu-patr.mobile .swipe").on("click", swipeleftHandler);
        $(".menu-patr.mobile").on("swipeleft", swipeleftHandler);

        // Callback function references the event target and adds the 'swipeleft' class to it
        function swipeleftHandler(event) {
            $('.menu-patr.mobile').removeClass('open');
            $('.menu-patr.mobile').addClass('closed');
        }

        $('.dropdown').hover(
            function () {
                $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn();
            },
            function () {
                $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut();
            }
        );

        $('.dropdown-menu').hover(
            function () {
                $(this).stop(true, true);
            },
            function () {
                $(this).stop(true, true).delay(200).fadeOut();
            }
        );

        function addSocketListeners() {

            MySocket.on('notification', (notification) => {
                vm.notifications.unshift(notification)
            })
        }

        function getNotifications() {
            Vue.backendApi().user(vm.$_user.id).getNotifications()
                .then(success, error);

            function success(response) {
                if (response) {
                    const sortedNotifications = response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    Vue.set(vm, 'notifications', sortedNotifications);
                } else {
                    vm.notifications = [];
                }
            }

            function error(error) {
                vm.$swal({
                    type: 'error',
                    title: 'Error loading notifications',
                    text: error
                });
            }
        }
    }
</script>

<style scoped>
    .offer .modal-header ul li:before {
        top: 2em;
        left: 0em;
        position: absolute;
    }

    .notification-time {
        position: absolute;
        right: 3em;
        top: 6px;
        font-size: 16px;
    }

    .notification-item {
        position: relative;
        padding: 2em;
    }

    .delete-notification-icon:hover {
        cursor: pointer;
    }

    .delete-notification-icon {
        position: absolute;
        top: -1px;
        right: 0px;
        padding: 5px;
    }

    .menu-button:hover {
        cursor: pointer;
    }

    .offer .modal-header ul li.read:before {
        background-color: black;
    }

    .menu-notification {
        display: flex;
        justify-content: center;
        position: absolute;
        z-index: 999999;
        top: 12px;
        width: 30px;
        background: #50d2c2;
        border-radius: 150px;
        height: 30px;
        right: 19px;
        padding: 2px 9px;
        color: #ffffff;
        font-size: 19px;
        -webkit-animation: beat 0.8s infinite alternate;
        -moz-animation: beat 0.8s infinite alternate;
        -ms-animation: beat 0.8s infinite alternate;
        -o-animation: beat 0.8s infinite alternate;
        animation: beat 0.8s infinite alternate;

        -webkit-transform-origin: center;
        -moz-transform-origin: center;
        -o-transform-origin: center;
        -ms-transform-origin: center;
        transform-origin: center;
    }

    @keyframes beat {
        to {
            -webkit-transform: scale(1.4);
            -moz-transform: scale(1.4);
            -o-transform: scale(1.4);
            -ms-transform: scale(1.4);
            transform: scale(1.4);
        }
    }
</style>

